import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class CheckUserIdAvailableUsecase {
  constructor(private readonly appAccountSettingRepo: AppAccountSettingRepository) {}

  async execute(loginId: string): Promise<SATResult<void, SATError>> {
    return this.appAccountSettingRepo.checkUserIdAvailable({ loginId: loginId.toLowerCase() });
  }
}
